
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/experience/[slug]",
      function () {
        return require("private-next-pages/experience/[slug]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/experience/[slug]"])
      });
    }
  